/* ireaders.shop — section behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------------- hero slider ---------------- */
  function initSlider(root) {
    if (root.dataset.irInit) return;
    root.dataset.irInit = '1';
    var track = root.querySelector('[data-ir-track]');
    var dots = root.querySelectorAll('[data-ir-dot]');
    var count = root.querySelectorAll('.ir-slide').length;
    var idx = 0, timer = null;
    if (!track || count === 0) return;

    function go(n) {
      idx = (n + count) % count;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
      }
    }
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-ir-dot]');
      if (d) { go(parseInt(d.dataset.irDot, 10)); restart(); return; }
      var a = e.target.closest('[data-ir-arrow]');
      if (a) { go(idx + parseInt(a.dataset.irArrow, 10)); restart(); }
    });

    var delay = parseInt(root.dataset.irAutoplay || '0', 10);
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { go(idx + 1); }, delay);
      }
    }
    go(0);
    restart();
  }

  /* ---------------- tabs ---------------- */
  function initTabs(root) {
    if (root.dataset.irInit) return;
    root.dataset.irInit = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ir-tab]');
      if (!btn) return;
      var key = btn.dataset.irTab;
      root.querySelectorAll('[data-ir-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ir-pane]').forEach(function (p) {
        p.classList.toggle('is-on', p.dataset.irPane === key);
      });
    });
  }

  /* ---------------- pdp ---------------- */
  function initProduct(root) {
    if (root.dataset.irInit) return;
    root.dataset.irInit = '1';

    var hero = root.querySelector('[data-ir-hero]');
    var idInput = root.querySelector('[data-ir-variant-id]');
    var atc = root.querySelector('[data-ir-atc]');
    var priceEl = root.querySelector('[data-ir-price]');
    var compareEl = root.querySelector('[data-ir-compare]');
    var pillEl = root.querySelector('[data-ir-pill]');
    var stickyPrice = root.querySelector('[data-ir-sticky-price]');
    var stickyInfo = root.querySelector('[data-ir-sticky-info]');

    var variants = [];
    var dataEl = root.querySelector('[data-ir-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    }

    /* gallery */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ir-thumb]');
      if (!t || !hero) return;
      root.querySelectorAll('[data-ir-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
      var img = t.querySelector('img');
      if (img) { hero.src = img.dataset.irFull || img.src; hero.srcset = ''; }
    });

    /* option selection */
    function selected() {
      var out = [];
      root.querySelectorAll('[data-ir-optgroup]').forEach(function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        out.push(on ? on.dataset.irValue : null);
      });
      return out;
    }

    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var sel = selected();
      var v = match(sel);

      root.querySelectorAll('[data-ir-optgroup]').forEach(function (g) {
        var label = g.querySelector('[data-ir-optvalue]');
        var on = g.querySelector('[aria-pressed="true"]');
        if (label && on) label.textContent = on.dataset.irValue;
      });

      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = atc.dataset.irUnavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;

      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available
          ? (atc.dataset.irAdd || 'Add to cart')
          : (atc.dataset.irSoldout || 'Sold out');
      }
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare || '';
        compareEl.classList.toggle('ir-hidden', !v.compare);
      }
      if (pillEl) {
        pillEl.textContent = v.save || '';
        pillEl.classList.toggle('ir-hidden', !v.save);
      }
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (stickyInfo) stickyInfo.textContent = v.title;
      if (v.image && hero) { hero.src = v.image; hero.srcset = ''; }

      if (window.history.replaceState && v.id) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ir-value]');
      if (!b) return;
      var group = b.closest('[data-ir-optgroup]');
      if (!group) return;
      group.querySelectorAll('[data-ir-value]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      update();
    });

    update();

    /* sticky bar */
    var sticky = root.querySelector('[data-ir-sticky]');
    var gal = root.querySelector('[data-ir-gallery]');
    if (sticky && gal) {
      var onScroll = function () {
        var past = window.scrollY > gal.offsetTop + gal.offsetHeight - 160;
        sticky.classList.toggle('is-on', past);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var stickyBtn = root.querySelector('[data-ir-sticky-add]');
    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }
  }

  /* ---------------- boot ---------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-ir-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-ir-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-ir-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* theme editor re-render */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
